module.exports = __webpack_public_path__ + "static/media/brand.f751e24b.png";